<template>
  <b-modal id="send-message-modal" title="Send Message" :ok-disabled="!body" @ok="sendMessage">
    <b-form>
      <b-form-input v-model="subject" placeholder="Subject" />

      <div class="message-editor mt-1">
        <quill-editor id="quil-content" v-model="body" :options="editorOption" />
        <div id="quill-toolbar" class="d-flex">
          <!-- Add a bold button -->
          <button class="ql-bold" />
          <button class="ql-italic" />
          <button class="ql-underline" />
        </div>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import { BModal, BForm, BFormInput } from 'bootstrap-vue'
import { quillEditor } from 'vue-quill-editor'

export default {
  components: {
    BForm,
    BModal,
    BFormInput,
    quillEditor,
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      subject: '',
      body: '',
    }
  },

  methods: {
    sendMessage() {
      this.$emit('send-message', {
        to: this.userData.email,
        subject: this.subject,
        message: this.body,
      })
    },

    resetData() {
      this.subject = ''
      this.body = ''
    },
  },

  setup() {
    const editorOption = {
      modules: {
        toolbar: '#quill-toolbar',
      },
      placeholder: 'Message',
    }

    return {
      editorOption,
    }
  },
}
</script>

<style lang="scss">
@import '@hw-ui/scss/vue/libs/quill.scss';
</style>

<style lang="scss" scoped>
form ::v-deep {
  // Quill Editor Style
  .quill-editor {
    min-height: 200px;
    padding: 0;
    border: 1px solid #d8d6de;
    border-radius: 0.357rem;
    .ql-container,
    .ql-editor {
      height: 200px !important;
      border: none !important;
    }
  }

  #quill-toolbar {
    border: none;
    border-radius: 0;
  }
}
</style>
